import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LoaderService} from './loader.service';
import {ModuleInterface} from '../shared/ModuleInterface';
import {Subject} from 'rxjs';
import {AuthService} from './auth.service';
import { io, Socket } from 'socket.io-client';


@Injectable()
export class SocketService {

  public module: ModuleInterface;
  private eventLeaflet2D = new Subject();

  protected socket!: Socket;

  constructor(
    public httpClient: HttpClient,
    public loaderService: LoaderService,
    public authService: AuthService
  ) {
    this.module = new ModuleInterface('socket', this.httpClient, this.loaderService);
    this.module.addAuthorizationInAllRequest();
    this.connect();
  }

  connect(): void {
    this.socket = io(this.module.getBaseUrl());

    this.socket.on('SNAP_PROGRESSION', (data, msg) => {
      this.eventLeaflet2D.next({data, msg});
    });
    this.socket.on('SNAP_ERROR', (data, msg) => {
      this.eventLeaflet2D.next({data, msg});
    });
    this.socket.on('SNAP_DONE', (data, msg) => {
      this.eventLeaflet2D.next({done: data});
    });
  }

  public getMap2DEventEmitter(): Subject<any> {
    return this.eventLeaflet2D;
  }

  public processMap(data: {
    icon: any;
    bbox: any;
    width: number;
    height: number;
    background: string;
    uuid_a0: string;
    echelle: { label: null; barWidth: number };
    hide_label_from_layers: any[];
    watercourse: any;
    watercourse_civ: any;
    code_zone: string;
    type_zone: string;
    list_layer_to_show: any[];
    show_niveau_layer: Array<string>;
    namefile: string;
    pcs_layer: any[];
    id_user: number;
    type_risque: string;
  }): void {
    this.socket.emit('SNAP', data);
  }
}
